// Function definitions
const search = function(params = {}){
    return window.axios.get('/api/emails', {
        params: params,
    });
};

const get = function(id){
    return window.axios.get('/api/emails/'+id);
};

const create = function(email){
    return window.axios.post('/api/emails', email);
};

const update = function(email){
    return window.axios.put('/api/emails/'+email.id, email);
};

const deleteEmail = function(email){
    return window.axios.delete('/api/emails/'+email.id, email);
};

const updateOrCreate = function(email) {
    if(email.id) {
        return update(email);
    } else {
        return create(email);
    }
};

const send = function (email) {
    return window.axios.post('/api/emails/send', email);
};

export default {
    search,
    get,
    create,
    update,
    delete: deleteEmail,
    updateOrCreate,
    send,
}


// WEBPACK FOOTER //
// ./resources/assets/js/services/EmailsService.js